/**
 * CargaResponsavel
 * @author Simpli CLI generator
 */
import {$, ID, Resource, TAG} from 'simpli-web-sdk'
import {
  ResponseSerialize,
  ValidationMaxLength,
  ValidationRequired,
} from 'simpli-web-sdk'
import Endereco from '@/model/resource/Endereco'
import Responsavel from '@/model/resource/Responsavel'
import ResponsavelFilial from '@/model/resource/ResponsavelFilial'
import CargaResponsavelSchema from '@/schema/CargaResponsavel.schema'
import {Exclude} from 'class-transformer'

export default class CargaResponsavel extends Resource {
  @Exclude()
  readonly $name: string = 'CargaResponsavel'

  @Exclude()
  readonly $endpoint: string = '/user/carga-responsavel{/id}'

  get $schema() {
    return CargaResponsavelSchema(this)
  }

  get $id() {
    /* TODO: define the ID */
    return 0
  }
  set $id(val: ID) {
    /* TODO: define the ID */
  }

  get $tag() {
    return this.responsavel.$tag
  }
  set $tag(val: TAG) {
    this.responsavel.$tag = val
  }

  @ResponseSerialize(Endereco)
  endereco = new Endereco()

  @ResponseSerialize(Responsavel)
  responsavel = new Responsavel()

  @Exclude()
  @ResponseSerialize(ResponsavelFilial)
  responsavelFilial: ResponsavelFilial | null = null

  @ValidationRequired()
  ehEmbarcador: boolean = false

  @ValidationMaxLength(255)
  inscricaoEstadual: string | null = null

  @ValidationMaxLength(255)
  substitutoTributario: string | null = null

  @ValidationMaxLength(255)
  inscricaoMunicipal: string | null = null

  @ValidationMaxLength(255)
  municipioIcms: string | null = null

  @ValidationMaxLength(255)
  cnaeFiscal: string | null = null

  @ValidationMaxLength(255)
  codigoRegimeTributario: string | null = null

  get idEnderecoFk() {
    if (!this.endereco) return 0
    return this.endereco.$id
  }
  set idEnderecoFk(idEnderecoFk: ID) {
    if (!this.endereco) this.endereco = new Endereco()
    this.endereco.$id = idEnderecoFk
  }

  get nome() {
    return this.responsavel.$tag
  }
  set nome(val: TAG) {
    this.responsavel.$tag = val
  }

  get cnpj() {
    return this.responsavel.cnpj
  }
  set cnpj(val: string) {
    this.responsavel.cnpj = val
  }

  get telefone() {
    return this.responsavel.telefone
  }
  set telefone(val: string | null) {
    this.responsavel.telefone = val
  }

  get email() {
    return this.responsavel.email
  }
  set email(val: string | null) {
    this.responsavel.email = val
  }

  idFilialFk: ID = 0

  get idResponsavelFk() {
    if (!this.responsavel) return 0
    return this.responsavel.$id
  }
  set idResponsavelFk(idResponsavelFk: ID) {
    if (!this.responsavel) this.responsavel = new Responsavel()
    this.responsavel.$id = idResponsavelFk
  }

  async persistCargaResponsavel(model?: CargaResponsavel, spinner = 'persistCargaResponsavel') {
    const fetch = async () => {
      if (model) await model.validate()
      return await this.POST(`/user/carga-responsavel`, model)
    }

    return await $.await.run(fetch, spinner)
  }

  async getCargaResponsavel(id: number, spinner = 'getCargaResponsavel') {
    const fetch = async () => await this.GET(`/user/carga-responsavel/${id}`)
    return await $.await.run(fetch, spinner)
  }
}
